export default "__VITE_ASSET__C7poc0Uq__"